import { lazy } from 'react'

export const EditorConsole = lazy(() => import('./editor-console'))
export const SubstituteUserContribute = lazy(() => import('./su-contribute'))
